import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import * as emiGlobals from 'app/globals';
import { LoanOfferGenService } from 'app/loan/services/loan-offer-gen.service';
import { forkJoin } from "rxjs/observable/forkJoin";
import { Subject } from "rxjs/Subject";

@Injectable()
export class CompanyOffersService {


  private headers: Headers;
  private options: RequestOptions;
  private ShowTheHlForm = new Subject<JSON>();
  private ShowThePlForm = new Subject<JSON>();

  private emiCompanyOfferUrl = emiGlobals.companySpecificUrl;
  private emileadSubmissionUrl = emiGlobals.commonLeadUrl;
  offerdata = new Array();
  ActualOffer;

  constructor(
    private _http: Http,
    private loanOfferService: LoanOfferGenService
  ) {
    this.doRequest();
  }

  // Observable show form on apply button click
  showHomeLoanForm$ = this.ShowTheHlForm.asObservable();
  // generate button click event
  ShowHl(data: JSON) {
    this.ShowTheHlForm.next(data);
  }
  // Observable show form on apply button click
  showPersonalLoanForm$ = this.ShowThePlForm.asObservable();
  // generate button click event
  ShowPl(data: JSON) {
    this.ShowThePlForm.next(data);
  }

  doRequest() {
    let token = localStorage.getItem('id_token');
    this.headers = new Headers({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    });
    this.headers.append('Authorization', 'Bearer ' + token);
    this.options = new RequestOptions({ headers: this.headers });
  }

  public handleError(error: Response) {
    console.log(error);
    return [];
  }

  public sentLeadInformation() {
    var totalLeadData = {};
    if (localStorage.getItem('lead_customer_info')) {

      var localData = JSON.parse(localStorage.getItem('lead_customer_info'));
      Object.keys(localData).forEach((key) => totalLeadData["ci_" + key] = localData[key]);
    }
    if (localStorage.getItem('lead_offer')) {

      var localData = JSON.parse(localStorage.getItem('lead_offer'));
      Object.keys(localData).forEach((key) => totalLeadData[key] = localData[key]);
      totalLeadData['bank_name'] = totalLeadData['name'];
      delete totalLeadData["name"];
    }
    if (localStorage.getItem('lead_contact')) {

      var localData = JSON.parse(localStorage.getItem('lead_contact'));
      Object.keys(localData).forEach((key) => totalLeadData[key] = localData[key]);
    }

    if (localStorage.getItem('agentInfo')) {

      var localData = JSON.parse(localStorage.getItem('agentInfo'));
      totalLeadData['agentInfo'] = localData;
    }

    if (!totalLeadData['lead_type']) {
      totalLeadData['lead_type'] = totalLeadData["prd_lead_type"];
      delete totalLeadData["prd_lead_type"];
    }
    delete totalLeadData['ci_salary_bank_account_id'];
    delete totalLeadData['ci_work_exp_id'];
    delete totalLeadData['ci_gender_id'];
    delete totalLeadData['ci_cogender_id'];
    delete totalLeadData['ci_coworkexp_id'];
    delete totalLeadData['ci_cobank_id'];
    delete totalLeadData['offerid'];
    delete totalLeadData['id'];
    delete totalLeadData['ci_location_id'];
    console.log('Actual Data to Api', totalLeadData);

    return this._http
      .post(this.emileadSubmissionUrl, totalLeadData, this.options)
      .map(response => response.json())
      .catch(this.handleError);

  }

  // Update customer form information with form data.
  public updateCustomerInfoData(newData) {
    var localCustomerData;
    var resultData = {};
    if (localStorage.getItem('lead_customer_info')) {
      localCustomerData = JSON.parse(localStorage.getItem('lead_customer_info'));
      Object.keys(localCustomerData).forEach((key) => resultData[key] = localCustomerData[key]);
    }
    Object.keys(newData).forEach((key) => resultData[key] = newData[key]);
    localStorage.setItem('lead_customer_info', JSON.stringify(resultData));
    console.log("updateCustomerInfoData -> ", resultData);
  }

  getFilteredBanks(data) {
    let filter_bank_id = JSON.parse(localStorage.getItem('PortalBank_Filter'));

    if (this.offerdata) {
      this.offerdata.length = 0;
    }
    if (filter_bank_id.length == 0) {
      this.offerdata = data;
      return this.offerdata;
    } else {
      if (data) {

        for (let j = 0; j < data.length; j++) {
          for (let i = 0; i < filter_bank_id.length; i++) {
            if (data[i]) {
              let bank = filter_bank_id[i];
              if (bank) {
                if (bank == data[j].id) {
                  this.ActualOffer = data[j];
                  this.offerdata.push(this.ActualOffer);
                }
              }
            } else {
              console.log("no data");
            }
          }
        }
        console.log(this.offerdata);
        return this.offerdata;

      }

    }
  }

  loadCompanyPageOffers(companyInfo) {
    console.log(companyInfo);
    var plOffer = {
      netsalary: companyInfo.pl_netsalary,
      existingemi: companyInfo.pl_emi,
      age: companyInfo.pl_age,
      emp_type: 1,
      employername: companyInfo.pl_id,
      purp: 1,
      loanamount: companyInfo.pl_loan_amount,
      loan_type: 'PersonalLoan',
      pid: 1,
      salarybankaccount: companyInfo.salarybank,
      loantenure: companyInfo.pl_tenure,
      workexp: companyInfo.workexp,
      location: companyInfo.location,
      gender: companyInfo.gender,
      domain: 2
    };

    var plBlOffer = Object.assign({}, plOffer);
    plBlOffer.purp = 6;
    plBlOffer.loan_type = 'Personal Loan Transfer';
    plBlOffer.pid = 7;

    var hlOffer = {
      netsal: companyInfo.pl_netsalary,
      ex_emi: companyInfo.pl_emi,
      bank: companyInfo.salarybank,
      workexp: companyInfo.workexp,
      age: companyInfo.pl_age,
      city: companyInfo.location,
      gender: companyInfo.gender,
      bonus: 0,
      sal: 1,
      company: companyInfo.hl_id,
      purp: 1,
      loanamt: companyInfo.hl_loan_amount,
      tenure: companyInfo.hl_tenure,
      propval: companyInfo.propvalue,
      depre: 0,
      loan_type: 'HomeLoan',
      pid: 1,
      domain: 2
    };


    var hlBlOffer = Object.assign({}, hlOffer);
    hlBlOffer.purp = 6;
    hlBlOffer.loan_type = 'Home Loan Transfer';
    hlBlOffer.pid = 1;



    let pl = this.loanOfferService.getPersoanlOffers(plOffer);
    let plBt = this.loanOfferService.getPersoanlOffers(plBlOffer);
    let hl = this.loanOfferService.getHomeOffers(hlOffer);
    let hlBt = this.loanOfferService.getHomeOffers(hlBlOffer);

    return forkJoin([pl, plBt, hl, hlBt]);
  }

  loadCustomCompanyPageOffersList(companyInfo) {
    debugger
    return this._http.get(emiGlobals.customCompanyOffers + '/' + companyInfo.company_url, this.options)
      .map(response => response.json())
      .catch(this.handleError);
  }

  getCustomOffersByProductPageId(id) {
    debugger
    return this._http.get(emiGlobals.customCompanyProductOffers + '/' + id, this.options)
      .map(response => response.json())
      .catch(this.handleError);
  }
  bankDetails(){
    this.doRequest();
    let url=emiGlobals.bankdetails;
 
    return this._http
    .get(url,this.options)
     .map((response:Response)=>{
       var res=response.json();
        if(res){
          return res;
        }
     });
  }

}



// WEBPACK FOOTER //
// ./src/app/company-offers/services/company-offers.service.ts